<template>
  <div class="flex flex-col">
    <div class="w-1/2 mb-4 flex flex-col gap-2">
      <div v-for="item in GUEST_OPTIONS" :key="item.id" class="flex items-center gap-2">
        <RadioButton
          :inputId="item.id"
          :value="item.value"
          v-model="guestOption"
          name="guestOptions"
        />
        <LabelDefault :forInput="item.id">{{ item.label }}</LabelDefault>
      </div>
    </div>
    <ReportDownloadAction
      :reportInCreationStatus="reportInCreationStatus"
      :isGeneratingReport="isGeneratingReport"
      :reportLink="reportInCreationLink"
      @generateReport="generateReport"
      @afterReportDownloaded="afterReportDownloaded"
    />
  </div>
</template>
<script setup lang="ts">
import RadioButton from 'primevue/radiobutton'
import { computed, ref } from 'vue'

import LabelDefault from '@/common/components/atoms/LabelDefault.vue'
import { Option } from '@/common/interfaces/Option'
import ReportDownloadAction from '@/modules/report/components/molecules/ReportDownloadAction.vue'
import { useGenerateReport } from '@/modules/report/composables/useGenerateReport'

import { GuestExportArgs } from '@generated/types'

const GUEST_OPTIONS: Option<string>[] = [
  { id: 'subscribe', label: 'Subscribe', value: 'subscribe' },
  { id: 'unsubscribe', label: 'Unsubscribe', value: 'unsubscribe' },
]
const guestOption = ref<string>(GUEST_OPTIONS[0].value)
const guestExportArgs = computed<GuestExportArgs>(function () {
  if (guestOption.value === 'subscribe') return { accepts_marketing: 'true' }
  return { no_accepts_marketing: 'true' }
})
const {
  afterReportDownloaded,
  generateReport,
  reportInCreationLink,
  isGeneratingReport,
  reportInCreationStatus,
} = useGenerateReport('guest', guestExportArgs)
</script>
